import { createReducerUsingActionHandlers, ERROR, PENDING, SUCCESS } from '@travel-frontend/state-handling-sdk';
import { curry } from 'lodash';
import { FETCH_HOTEL_DATA_DETAILED } from '../../../../components/HotelDetailsOverlay/redux/hotelDataDetailed/models.js';
const initialState = {
  status: {},
  data: {},
  errors: {}
};
const actionHandlers = {
  [PENDING(FETCH_HOTEL_DATA_DETAILED)]: (state, action) => ({
    ...state,
    status: {
      ...state.status,
      [action.meta.hotelId]: 'loading'
    }
  }),
  [SUCCESS(FETCH_HOTEL_DATA_DETAILED)]: (state, action) => ({
    ...state,
    status: {
      ...state.status,
      [action.meta.hotelId]: 'successful'
    },
    data: {
      ...state.data,
      [action.meta.hotelId]: action.payload
    }
  }),
  [ERROR(FETCH_HOTEL_DATA_DETAILED)]: (state, action) => ({
    ...state,
    status: {
      ...state.status,
      [action.meta.hotelId]: 'failed'
    },
    errors: {
      ...state.errors,
      [action.meta.hotelId]: action.error
    }
  })
};
export const hotelDataDetailedState = state => state.v1.hotelDataDetailed;
export const reducer = createReducerUsingActionHandlers(initialState, actionHandlers);
export const selectStatusById = curry((hotelId, state) => hotelDataDetailedState(state).status[hotelId] || 'idle');
export const selectDataById = curry((hotelId, state) => hotelDataDetailedState(state).data[hotelId]);
export const selectErrorById = curry((hotelId, state) => hotelDataDetailedState(state).errors[hotelId]);